import { render, staticRenderFns } from "./NotSustainedReport.vue?vue&type=template&id=07dcdc41&scoped=true"
import script from "./NotSustainedReport.vue?vue&type=script&lang=js"
export * from "./NotSustainedReport.vue?vue&type=script&lang=js"
import style0 from "./NotSustainedReport.vue?vue&type=style&index=0&id=07dcdc41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dcdc41",
  null
  
)

export default component.exports